import { createRoute } from '@tanstack/react-router'
import { Route as appLayoutRoute } from '../layout'

export const Route = createRoute({
  getParentRoute: () => appLayoutRoute,
  path: '/hr/org-chart',
}).lazy(() => import('./org-chart.lazy').then((d) => d.Route))
